var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sorting",attrs:{"aria-label":"Sort assets"}},[_c('Dropdown',{staticClass:"dropdown",class:{ loading: _vm.loading },attrs:{"size":'lg',"options":_vm.types,"sort-by":true,"default-option":_vm.sortBy.toString()},on:{"change":_vm.changeSortBy}}),(_vm.loading)?_c('div',{staticClass:"sorting__loader loader-rounded"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }